import { observer } from 'mobx-react';

import Layout from 'components/Layout';
import LoginForm from 'components/Login';
import MaintenanceAlert from 'components/MaintenanceAlert';
import { useHiddenNav, useTitle } from 'hooks';

const Login = () => {
  useHiddenNav();
  useTitle('Login');

  return (
    <>
      <MaintenanceAlert />
      <Layout>
        <LoginForm />
      </Layout>
    </>
  );
};

Login.public = true;

export default observer(Login);
